import * as React from 'react';

import Info16 from './Info16';

export const info16 = () => <Info16 />;

export default {
    title: 'Icon/Fill/Info16',
    component: Info16,
    parameters: {
        notes: "`import Info16 from 'box-ui-elements/es/icon/fill/Info16';`",
    },
};
